<div class="size-full p-7 flex flex-col">
    <div class="mb-4 text-left text-vms-text-dark text-lg font-bold">MDA Settings</div>
    <div class="grow overflow-x-auto">
        <table class="border-collapse w-full">
            <thead class="bg-[#F4F4F4]">
                <tr>
                    <th class="p-3 text-sm text-[#595A69] font-semibold">MDA Name</th>
                    <th class="p-3 text-sm text-[#595A69] font-semibold">MDA Code</th>
                    <th class="p-3 text-sm text-[#595A69] font-semibold">Logo</th>
                    <th class="p-3 text-sm text-[#595A69] font-semibold">Brand Colors</th>
                    <th class="p-3 text-sm text-[#595A69] font-semibold">Signature</th>
                    <th class="p-3 text-sm text-[#595A69] font-semibold">Action</th>
                </tr>
            </thead>
            <tbody>
                @if (isLoadingMdaDetails) {
                     <tr>
                        <td colspan="6" class="px-6 py-16 text-center">
                            <div class="flex flex-col items-center gap-3">
                            <div
                                class="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-vms-bg-secondary"
                            ></div>
                            <p class="text-sm font-medium text-slate-500">Loading settings...</p>
                            </div>
                        </td>
                    </tr>
                } @else {
                    @for (mdaDetailsItem of mdaDetailsItemList; track $index) {
                        <tr class="[&>*]:p-3">
                            <td>{{ mdaDetailsItem.name || "N/A" }}</td>
                            <td>{{ mdaDetailsItem.code || 'N/A' }}</td>
                            <td class="flex items-center justify-center">
                                <img 
                                    [src]="mdaDetailsItem.logo" 
                                    alt="mda logo"
                                    class="size-20 object-contain object-center"
                                >
                            </td>
                            <td>
                                <div class="h-8 grid grid-cols-2 gap-2">
                                    <div class="size-full rounded" [style.backgroundColor]="mdaDetailsItem.primaryColor"></div>
                                    <div class="size-full rounded" [style.backgroundColor]="mdaDetailsItem.secondaryColor"></div>
                                </div>
                            </td>
                            <td class="flex items-center justify-center">
                                <img 
                                    [src]="mdaDetailsItem.headSignature" 
                                    alt="head signature"
                                    class="size-20 object-contain object-center"
                                >
                            </td>
                            <td>
                                <div class="flex items-center justify-center" (click)="onEdit(mdaDetailsItem)">
                                    <svg class="size-6 text-amber-400 cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                                        <path d="M0 0h24v24H0z" fill="none" />
                                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                                            <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                            <path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z" />
                                        </g>
                                    </svg>
                                </div>
                            </td>
                        </tr>
                    } @empty {
                        <tr>
                            <td colspan="6" class="p-4 text-center">No mda settings found.</td>
                        </tr>
                    }
                }
            </tbody>
        </table>
    </div>

    @if (isSuperAdmin) {
        <div class="flex items-center justify-between px-6 py-4 border-t border-slate-100 bg-slate-50/50">
            <p class="text-xs text-slate-400">
              Showing {{ mdaDetailsItemList.length }} of {{ totalItems }} payments
            </p>
            <div class="flex items-center gap-1">
              <button
                (click)="goToPreviousPage()"
                [disabled]="!hasPreviousPage"
                class="px-3 py-1.5 text-xs text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-md transition-colors duration-150 disabled:opacity-40"
              >
                Previous
              </button>
              <button
                class="px-3 py-1.5 text-xs bg-vms-bg-secondary text-vms-text-secondary rounded-md shadow-sm"
              >
                {{ currentPage }}
              </button>
              <button
                (click)="goToNextPage()"
                [disabled]="!hasNextPage"
                class="px-3 py-1.5 text-xs text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-md transition-colors duration-150 disabled:opacity-40"
              >
                Next
              </button>
            </div>
        </div>
    }
</div>

@if (showModal && selectedMdaDetailsItem) {
    <app-mda-settings-modal
        [open]="showModal"
        [targetMdaId]="selectedMdaDetailsItem.mdaId"
        (close)="handleModalClose()"
    ></app-mda-settings-modal>
}